const t = "Ukończony krok", o = "Wróć do: {buttonName}", e = "Dalej do: {buttonName}", n = {
  completedStep: t,
  backButton: o,
  nextButton: e
};
export {
  o as backButton,
  t as completedStep,
  n as default,
  e as nextButton
};
